/**
 * Phase N.14 (2026-02) — SAFER status badge color logic.
 *
 * Prior bug: ``FmcsaLookupCard :: statusChipClass`` returned emerald
 * for any status text containing "ACTIVE" OR "AUTHORIZED", so
 * ``"ACTIVE · NOT AUTHORIZED"`` rendered green — contradicting the
 * red risk banner shown alongside it.
 *
 * Correct semantics:
 *   ACTIVE + AUTHORIZED       → emerald  (fully compliant)
 *   ACTIVE + NOT AUTHORIZED   → amber    (operating but no for-hire
 *                                        interstate authority — caution)
 *   INACTIVE / OUT OF SERVICE → rose     (blocking risk)
 *   anything else / unknown   → slate    (neutral)
 *
 * Matching is case-insensitive substring against the composed status
 * label ``"<operating_status> · <operating_authority_status>"`` (see
 * ``FmcsaLookupCard.displayStatus``). The ``NOT AUTHORIZED`` check
 * runs BEFORE the ``AUTHORIZED`` check so ``NOT`` is not shadowed.
 */
export function saferBadgeClasses(statusText) {
    const s = String(statusText || "").toUpperCase();
    if (s.includes("OUT OF SERVICE") || s.includes("INACTIVE")) {
        return "bg-rose-50 text-rose-800 ring-rose-200 border-rose-200";
    }
    if (s.includes("NOT AUTHORIZED")) {
        return "bg-amber-50 text-amber-900 ring-amber-200 border-amber-200";
    }
    if (s.includes("AUTHORIZED") || s.includes("ACTIVE")) {
        return "bg-emerald-50 text-emerald-800 ring-emerald-200 border-emerald-200";
    }
    return "bg-slate-50 text-slate-700 ring-slate-200 border-slate-200";
}
